goog.provide("shadow.js.shim.module$react_bootstrap$Collapse$default");
shadow.js.shim.module$react_bootstrap$Collapse$default = shadow.js.require(55, {})["default"];
